import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../app-constants.service';
import { VertragData } from '../../generated/api/kreditportalBackendAPI.schemas';

@Component({
    selector: 'elem-vertrag-short',
    templateUrl: './vertrag-short.component.html',
    styleUrls: ['./vertrag-short.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VertragShortComponent implements OnDestroy {

    @Input()
    vertrag: VertragData;

    @Input()
    odd: boolean;

    constructor(
        private readonly router: Router,
        private readonly appConstants: AppConstants,
    ) {
    }

    ngOnDestroy() {
        this.vertrag = null;
    }

    isAuslastungWarning(): boolean {
        return Math.round(this.vertrag.rahmenBelastung * 100 / this.vertrag.rahmenBetrag) >= this.appConstants.VERTRAG_AUSLASTUNG_WARNING_OVER;
    }

    gotoVertrag(): void {
        if (!this.vertrag.fehlerText) {
            this.router.navigate(['./kreditportal/vertraege/', this.vertrag.vertragHandle.vsnrNumerisch]);
        }
    }

}
